const chartConfig = {
  barMaxWidth: 35,
  // textFontFamily: 'STSong-Light',
  // textFontFamily: 'STSONG',
  // textFontFamily: '华文宋体',
  textFontFamily: '宋体',
  numberFontFamily: 'Times New Roman'
}

const COLORS = [
  '#3ba272',
  '#F44336',
  '#7E57C2',
  '#29B6F6',
  '#26A69A',
  '#8BC34A',
  '#FFEE58',
  '#FF9800',
  '#607D8B',
  '#795548',
  '#EC407A',
  '#AB47BC',
  '#26C6DA',
  '#fe7300',
  '#66BB6A',
  '#D4E157',
  '#FFCA28'
]

const GRID_DEFAULT_RIGHT = 35

const Y_AXIS_GROUP_INTERVAL = 60

const FONT_SIZE = 11

export default class ChartUtil {
  static getOpt ({dimensions, unitProp, dataTimes, dateFormat, seriesMap}) {
    const units = this.getUnits(dimensions, unitProp)
    const unitsLen = units.length

    const grid = {
      top: 45,
      right: unitsLen <= 1 ? GRID_DEFAULT_RIGHT : (unitsLen - 1) * Y_AXIS_GROUP_INTERVAL,
      bottom: 20,
      left: Y_AXIS_GROUP_INTERVAL,
      containLabel: false
    }

    const yAxisMap = units.reduce((map, unit, index) => {
      map[unit] = {
        index,
        show: true,
        type: 'value',
        name: unit,
        nameTextStyle: {
          fontSize: FONT_SIZE,
          fontFamily: chartConfig.textFontFamily
        },
        position: index === 0 ? 'left' : 'right',
        offset: index < 2 ? 0 : ((index - 1) * Y_AXIS_GROUP_INTERVAL),
        axisLine: {
          show: true
        },
        splitLine: {
          show: index === 0
        },
        axisTick: {
          show: true
        },
        axisLabel: {
          fontSize: FONT_SIZE,
          fontFamily: chartConfig.numberFontFamily
        },
        scale: true
      }

      return map
    }, {})

    const COLORS_LEN = COLORS.length
    const series = dimensions.map((dimension, index) => {
      let {id} = dimension
      let dataMap = seriesMap[id]

      return {
        id,
        name: dimension.name,
        yAxisIndex: yAxisMap[dimension[unitProp]].index,
        color: COLORS[index % COLORS_LEN],
        data: dataTimes.map(dataTime => dataMap[dataTime[1]]),
        ...dimension.seriesParam
      }
    })
    const yAxis = Object.values(yAxisMap)

    return {
      tooltip: {
        trigger: 'axis',
        appendToBody: true
      },
      legend: {
        top: 0,
        left: 'center',
        textStyle: {
          fontSize: FONT_SIZE,
          fontFamily: chartConfig.textFontFamily
        }
      },
      grid,
      xAxis: {
        type: 'category',
        data: dataTimes.map(dataTime => dataTime[2]),
        axisTick: {
          alignWithLabel: true
        },
        axisLabel: {
          fontSize: FONT_SIZE,
          fontFamily: chartConfig.textFontFamily,
          formatter: value => dateFormat ? new Date(value).format(dateFormat) : value
        }
      },
      yAxis,
      series
    }
  }

  static getUnits (dimensions, unitProp) {
    return [...new Set(dimensions.map(dimension => dimension[unitProp]))]
  }
}



// WEBPACK FOOTER //
// ./src/components/ReportChart/ChartUtil.js